module.exports = __webpack_public_path__ + "static/media/girl1.23d0b5a7.svg";